import { render, staticRenderFns } from "./BaseTransactionDetailsPix.vue?vue&type=template&id=5938b9ec&"
import script from "./BaseTransactionDetailsPix.vue?vue&type=script&lang=js&"
export * from "./BaseTransactionDetailsPix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports